import lodash from 'lodash';
import { BookingStatus } from '../../types';
import { HolidayActionKind } from './holidayActionKind';
export const holidayReducer = (state, { type, payload }) => {
    switch (type) {
        case HolidayActionKind.AddHoliday: {
            return {
                ...state,
                holidays: [...state.holidays, payload],
            };
        }
        case HolidayActionKind.RemoveHoliday: {
            const indexToRemove = state.holidays.indexOf(payload);
            const holidays = [...state.holidays];
            holidays.splice(indexToRemove, 1);
            return {
                ...state,
                holidays,
            };
        }
        case HolidayActionKind.InitialiseHolidays: {
            return {
                ...state,
                holidays: payload,
            };
        }
        case HolidayActionKind.AddHolidayBooking: {
            if ([BookingStatus.Approved, BookingStatus.Pending].includes(payload.approvalStatusNumber)) {
                return {
                    ...state,
                    holidayBookings: lodash.uniqBy([...state.holidayBookings, payload], (hb) => hb.bookingId),
                };
            }
            else {
                return state;
            }
        }
        case HolidayActionKind.RemoveHolidayBooking: {
            return {
                ...state,
                holidayBookings: state.holidayBookings.filter((h) => h.bookingId !== payload),
            };
        }
        case HolidayActionKind.UpdateHolidayBooking: {
            const indexToUpdate = state.holidayBookings.findIndex((holidayBooking) => holidayBooking.bookingId === payload.bookingId);
            const holidayBookings = [...state.holidayBookings];
            holidayBookings[indexToUpdate] = payload;
            return {
                ...state,
                holidayBookings,
            };
        }
        case HolidayActionKind.InitialiseHolidayBookings: {
            return {
                ...state,
                holidayBookings: payload,
            };
        }
        default:
            return state;
    }
};
